module.exports = {"500152001":"桂林街道","500152002":"梓潼街道","500152101":"上和镇","500152102":"龙形镇","500152103":"古溪镇","500152104":"宝龙镇","500152107":"玉溪镇","500152108":"米心镇","500152109":"群力镇","500152110":"双江镇","500152112":"花岩镇","500152113":"柏梓镇","500152114":"崇龛镇","500152115":"塘坝镇","500152116":"新胜镇","500152117":"太安镇","500152119":"小渡镇","500152120":"卧佛镇","500152121":"五桂镇","500152122":"田家镇","500152123":"别口镇","500152124":"寿桥镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500152.json
// module id = 2056
// module chunks = 0